import axios from "axios";
import '../../styles/TripEditor.css';
import { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../ToastContext";

function UpdateTrip() {
    const API_URL = process.env.REACT_APP_API_URL;
    
    const { showToast } = useToast();
    const navigate = useNavigate();
    const tripId = localStorage.getItem("tripId");
    const countryName = localStorage.getItem("selectedCountryName");
    const countryId = localStorage.getItem("selectedCountryDbId");
    const userId = localStorage.getItem("userId")

    const [titleData, setTitleData] = useState("");
    const [descriptionData, setDescriptionData] = useState("");
    const [arrivalDateData, setArrivalDateData] = useState("");
    const [departureDateData, setDepartureDateData] = useState("");
    const [photos, setPhotos] = useState([]);

    const maxCharLimit = 3000;

    const textareaRef = useRef(null);
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
        }
    }, [descriptionData]);

    function toInputFormat(dateString) {
        if (dateString.includes("-")) {
            return dateString;
        }

        const [day, month, year] = dateString.split(".");
        return `${year}-${month}-${day}`;
    }

    useEffect(() => {
        axios.get(`${API_URL}/trips/trip/${tripId}`)
            .then(response => {
                setTitleData(response.data.title);
                setArrivalDateData(toInputFormat(response.data.arrivalDate));
                setDepartureDateData(toInputFormat(response.data.departureDate));
                setDescriptionData(response.data.description);
            })
            .catch(error => {
                console.error("Błąd pobierania danych wybranej wycieczki: ", error);
            });
    }, [tripId]);

    const handleReset = () => {
        setArrivalDateData('');
        setTitleData('');
        setDescriptionData('');
        setDepartureDateData('');
    };

    const updateTrip = (e) => {
        e.preventDefault();
        const tripData = {
            id: Number(tripId),
            title: titleData,
            description: descriptionData,
            arrivalDate: arrivalDateData,
            departureDate: departureDateData,
            userId: Number(userId),
            countryId: Number(countryId)
        }

        axios.put(`${API_URL}/trips/trip/${tripId}`, tripData)
            .then(() => {
                setTitleData("");
                setDescriptionData("");
                setArrivalDateData("");
                setDepartureDateData("");

                showToast("Wpis został zaaktualizowany", "success")
                navigate("/globus");
            })
            .catch(error => {
                console.error("Błąd edycji dnaych wpisu: ", error);
                showToast("Wystąpił błąd edycji wpisu, spróbuj ponownie", "error")
            });



    }
    return (
        <div className="NewTripEditor">
            <button className="backButton" onClick={() => navigate('/globus')}>Cofnij</button>
            <form onSubmit={updateTrip} onReset={handleReset}>
                <h1>Edycja wpisu</h1>
                <h3>Kraj: {countryName}

                </h3>
                <p>Data przyjazdu:
                    <input type='date' value={arrivalDateData} onChange={(e) => setArrivalDateData(e.target.value)} max={departureDateData} required></input>
                </p>

                <p>Tytuł:
                    <input type='text' value={titleData} onChange={(e) => setTitleData(e.target.value)} maxLength={50} />
                </p>

                <p>Opis:
                    <div style={{ position: 'relative', width: '100%' }}>
                        <textarea
                            ref={textareaRef}
                            maxLength={maxCharLimit}
                            placeholder="Opisz swoją podróż..."
                            value={descriptionData}
                            onChange={(e) => setDescriptionData(e.target.value)}
                            required
                            style={{
                                width: '100%',
                                boxSizing: 'border-box',
                                paddingBottom: '30px',
                                resize: 'vertical',
                                height: '200px',
                            }}
                        ></textarea>
                        <span
                            style={{
                                position: 'absolute',
                                bottom: '10px',
                                right: '12px',
                                fontSize: '0.85rem',
                                color: (descriptionData?.length || 0) >= maxCharLimit ? '#d9534f' : '#888',
                                pointerEvents: 'none',
                                userSelect: 'none',
                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                padding: '2px 6px',
                                borderRadius: '4px'
                            }}
                        >
                            {descriptionData?.length || 0}/{maxCharLimit}
                        </span>
                    </div>
                </p>
                <p>Data wyjazdu:
                    <input type='date' value={departureDateData} onChange={(e) => setDepartureDateData(e.target.value)} required min={arrivalDateData}></input>
                </p>

                <div className='buttons'><button type='submit'>Edytuj wpis</button><button type='reset'>Wyczyść</button></div>
            </form>
            <br></br>

            {/*ZDJECIA */}
            <div className='photosGrid'>
                {photos.map((file, index) => (
                    <div className='photoTile'>
                        <img
                            key={index}
                            src={URL.createObjectURL(file)}
                            alt=""
                            width="100"
                            style={{ borderRadius: "8px" }}
                        />

                        <button className="deletePhoto" onClick={() => setPhotos(prev => prev.filter((_, i) => i !== index))}>{/*zapisywanie wszystkich zdjęć w setPhotos poza wybranym do usunięcia*/}
                            ✕
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );


}
export default UpdateTrip;